/**
 * The neutral surface shown while the app is deciding whether there is a session at all — i.e. while
 * `GET /api/v1/me` is in flight on cold load. It is deliberately NOT a designed screen: it must not
 * flash any authenticated chrome, and it must not be the login page (which would flash for the
 * authenticated majority). The login screen and its brand surface are F5-a WI-1.2's.
 *
 * Follows the existing loading convention in `RouteSkeleton.tsx` — a fixed region with `aria-busy`
 * so the wait is perceivable to a screen reader (§3.2), tokens only, no spinner — sized to the
 * viewport because it stands in for the whole app, not one route's outlet.
 */
export function BootstrapGate() {
    return (
        <div
            aria-busy="true"
            aria-live="polite"
            data-testid="bootstrap-gate"
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // §5's loading surface, matching RouteSkeleton.
                background: 'var(--et-surface-card-warm)',
                color: 'var(--et-text-secondary)',
                fontSize: 'var(--et-type-secondary-size)',
            }}
        >
            <span>Loading…</span>
        </div>
    );
}
